import { Theme } from "@mui/material";
import { makeStyles } from "tss-react/mui";

export const baseGridRootStyles = (theme: Theme) => ({
  WebkitFontSmoothing: "auto",
  letterSpacing: "normal",
  "& .MuiDataGrid-main": {
    borderBottom: "1px solid",
    borderBottomColor: theme.vars.palette.background.paper,
  },
  "& .MuiDataGrid-columnHeaderTitle": {
    color: theme.vars.palette.text.secondary,
    fontSize: "0.625rem",
  },
  "& .MuiDataGrid-columnHeader, .MuiDataGrid-cell": {
    "& .MuiDataGrid-columnSeparator": {
      color: theme.vars.palette.background.inverted,
    },
    "&:last-child": {
      "& .MuiDataGrid-columnSeparator": {
        display: "none",
      },
    },
  },
  // The theme's small Checkbox is 20px; grid rows are 24px, so selection
  // checkboxes shrink to match what Configuration and Pricing already do.
  "& .MuiDataGrid-checkboxInput svg": {
    fontSize: "1rem",
  },
  "& .MuiPaginationItem-root": {},
  "& .MuiTablePagination-root": {
    "& .MuiTablePagination-selectIcon": {
      color: theme.vars.palette.text.secondary,
    },
    "& .MuiButtonBase-root.Mui-disabled": {
      color: theme.vars.palette.action.disabled,
    },
  },
  "& .MuiDataGrid-columnHeader--sorted.MuiDataGrid-columnHeader--sortable.MuiDataGrid-columnHeader":
    {
      outline: `solid 1px ${theme.vars.palette.primary.main}`,
      outlineWidth: "1px",
      outlineOffset: "-1px",
    },
  "& .MuiDataGrid-overlay": {
    backgroundColor: theme.vars.palette.background.paper,
  },
  "& *::-webkit-scrollbar-thumb": {
    border: `2px solid ${theme.vars.palette.background.sunken}`,
    borderRadius: "5px",
    backgroundColor: theme.vars.palette.action.disabled,
  },
  "& *::-webkit-scrollbar-corner, & *::-webkit-scrollbar": {
    backgroundColor: theme.vars.palette.background.sunken,
  },
});

/** Where a grid stops growing and starts scrolling, in pixels. */
export const GRID_MAX_HEIGHT = 800;

export const baseGridPaperStyles = () => ({
  boxShadow: "unset" as const,
  height: "100%",
  maxHeight: `${GRID_MAX_HEIGHT}px`,
  width: "100%",
});

export const dataGridStyles = makeStyles()((theme: Theme) => ({
  root: baseGridRootStyles(theme),
  paper: baseGridPaperStyles(),
}));

export const toolbarStyles = makeStyles()((theme: Theme) => ({
  tableHeader: {
    backgroundColor: theme.vars.palette.background.default,
  },
}));
